import { render } from "./PurchasesDetailsListPage.vue?vue&type=template&id=a8d45364&ts=true"
import script from "./PurchasesDetailsListPage.vue?vue&type=script&lang=ts"
export * from "./PurchasesDetailsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__